module.exports = __webpack_public_path__ + "static/media/tree-step-5_3.01137df8.svg";